import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyTimepickerComponent } from './formly-timepicker.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    NgxMatTimepickerModule,
    ReactiveFormsModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'timepicker',
          component: FormlyTimepickerComponent,
          // wrappers: ['form-field'],
        },
      ],
    }),
  ],
  declarations: [FormlyTimepickerComponent],
})
export class FormFieldsTimepickerModule {}
